import React from 'react';
import styled from 'styled-components';
import Title from '../../Components/Text/Title';
import BasicButton from '../../Components/Button/BasicButton';
import ScrollAnimation from 'react-animate-on-scroll';

import wallet_bg from '../../Images/wallet_bg.png'
import wallet_img from '../../Images/wallet_img.png'
import appStore_img from '../../Images/appStore_img.png';
import googlePlay_img from '../../Images/googlePlay_img.png';
import game_bg_img_top from '../../Images/game_bg_img_top.png';
import game_bg_img_bottom from '../../Images/game_bg_img_bottom.png';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  overflow: hidden;
  padding-top: 180px;
  padding-bottom: 280px;
  background-image: url(${wallet_bg});
  background-size: cover;
  background-position: center;
`
const SubContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 970px;
  position: relative;
  z-index: 10;
  justify-content: center;
  align-items: center;
  @media (max-width: 1010px) {
    width: 100%;
    padding: 0 20px;
  };
`
const RowContainer = styled.div`
  margin-top: 60px;
  display: flex;
  width: 100%;
  justify-content: center;
  & > img { 
    width: 320px;
  }
  & > div {
    margin-top: 140px;
    margin-left: auto;
    width: 470px;
    & > div {
      & > p {
        color: white;
        white-space: pre-line;
      }
      & > p:nth-child(1) {
        font-size: 28px;
        font-weight: 600;
      }
      & > p:nth-child(2) {
        margin-top: 20px;
        font-size: 17px;
        font-weight: 200;
        line-height: 180%;
      }
    }
  }
  @media (max-width: 1010px) {
    flex-direction: column;
    align-items: center;
    & > div {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      margin-left: 0;
      margin-top: 60px;
      width: auto;
      & > p {
        text-align: center;
      }
    }
  };
  @media (max-width: 570px) {
    & > img {
      width: 80%
    }
  };
`
const ButtonContainer = styled.div`
  margin-top: 40px;
  display: flex;
  flex-direction: row;
  & > div {
    margin-top: 20px;
  }
  & > div + div {
    margin-left: 20px;
  }
  @media (max-width: 520px) {
    flex-direction: column;
    & > div + div {
      margin-left: 0;
    }
  };
`
const TopBg = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 0;
  display: flex;
  justify-content: center;
  & > img {
    opacity: 0.3;
  }
`
const BottomBg = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  z-index: 0;
  display: flex;
  justify-content: center;
  & > img {
    opacity: 0.3;
  }
`

const WalletContainer = ({ language }) => {
  return (
    <Container>
      <SubContainer>
        <Title
          text={'G-Wallet'}
          color={'yellow'}
        />
        <RowContainer>
          <img alt="" src={wallet_img} />
          <div>
            <ScrollAnimation animateIn='fadeIn' duration="2">
              <p>GREX Wallet</p>
              <p>{
                language === 'Korean' ?
                `∙ 제휴 게임화폐 및 가상자산을 통합 관리할 수 있는 전자지갑\n∙ 공시, 투표, 이벤트 등 정보 알림\n∙ 게임 멤버십 및 아이템 NFT 관리`
                :
                `∙ Electronic wallet with which users can comprehensively manage affiliate game currency and virtual assets\n∙ Notification of information such as public announcements, voting, and events\n∙ Management of game membership and item NFT`
              }</p>
            </ScrollAnimation>
            <ButtonContainer>
              <BasicButton
                // href={"https://apps.apple.com/kr/app/%EC%97%90%EC%9D%B4%EB%9D%BD-%EC%9B%94%EB%A0%9B-alock-wallet/id1576791642"}
                style={{ width: 180 }}
                img={appStore_img}
                imgStyle={{ width: 18, marginTop: -2 }}
                fontSize={'15px'}
                text={'App Store'}
                bgColor={'#FF8E00'}
                coming={true}
              />
              <BasicButton
                // href={"https://play.google.com/store/apps/details?id=com.alock.wallet"}
                style={{ width: 180 }}
                img={googlePlay_img}
                imgStyle={{ width: 18, marginTop: -2 }}
                fontSize={'15px'}
                text={'GooglePlay'}
                bgColor={'#FF8E00'}
                coming={true}
              />
            </ButtonContainer>
          </div>
        </RowContainer>
      </SubContainer>
      <TopBg>
        <img alt="" src={game_bg_img_top} />
      </TopBg>
      <BottomBg>
        <img alt="" src={game_bg_img_bottom} />
      </BottomBg>
    </Container>
  )
}

export default WalletContainer;